"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initSelectedNode = exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _reactBootstrap = require("react-bootstrap");
var _Drawer = _interopRequireDefault(require("@mui/material/Drawer"));
var _radioButton = _interopRequireDefault(require("../../../radioButton"));
var _spinner = _interopRequireDefault(require("../../../spinner"));
var _styles = _interopRequireDefault(require("../styles.scss"));
var _buttonV = _interopRequireDefault(require("../../../buttonV2"));
var _styles2 = require("../styles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var AWARDEE_LEVEL = 1;
/**
 * Init selectedNode, auto select node if all levels have only one entity
 * @param orgStructure
 */
var initSelectedNode = function initSelectedNode(orgStructure) {
  if (_lodash.default.isEmpty(orgStructure)) {
    return null;
  }
  for (var i = 0; i < orgStructure.length; i += 1) {
    if (orgStructure[i].nodes && orgStructure[i].nodes.length !== 1) {
      return null;
    }
  }
  return orgStructure[orgStructure.length - 1].nodes[0];
};
exports.initSelectedNode = initSelectedNode;
var SingleDrawer = function SingleDrawer(props) {
  var onClose = props.onClose,
    show = props.show,
    onSave = props.onSave,
    orgStructure = props.orgStructure,
    isLoading = props.isLoading,
    enableClearSelection = props.enableClearSelection,
    t = props.t;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    showDetailPane = _useState2[0],
    setShowDetailPane = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    selectedNode = _useState4[0],
    setSelectedNode = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    orgNodesDetail = _useState6[0],
    setOrgNodesDetail = _useState6[1];
  var _useState7 = (0, _react.useState)(),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    selectedOrg = _useState8[0],
    setSelectedOrg = _useState8[1];
  (0, _react.useEffect)(function () {
    if (props.selectedNode) {
      setSelectedNode(props.selectedNode);
    } else {
      var initNode = initSelectedNode(orgStructure);
      setSelectedNode(initNode);
      onSave(initNode);
    }
  }, [orgStructure]);

  /**
   * Get level by node path
   * @param {String} path //nodePath
   */
  var getLevelByNodePath = function getLevelByNodePath(path) {
    var nodeLevel = -1;
    _lodash.default.forEach(orgStructure, function (org) {
      var level = org.level;
      var orgContainPath = _lodash.default.find(org.nodes, {
        nodePath: path
      });
      if (orgContainPath) {
        nodeLevel = level;
      }
    });
    return nodeLevel;
  };

  /**
   * Filter nodes to show in structure detail panel
   * @param {Number} selectedOrganization // seleted level
   */
  var filterSelectedOrgNodes = function filterSelectedOrgNodes(selectedOrganization) {
    var selectedOrgNodes = _lodash.default.find(orgStructure, {
      level: selectedOrganization
    }).nodes;
    // Only return selection relative nodes of selected node
    // And show all node that is a highest level
    if (selectedNode && !_lodash.default.isNil(selectedOrgNodes) && selectedOrganization !== AWARDEE_LEVEL) {
      var selectedNodeLevel = getLevelByNodePath(selectedNode.nodePath);
      var parentNodePath = selectedNode.nodePath;
      if (selectedNodeLevel >= selectedOrganization) {
        // get parent nodePath if selectedNode is child of selected organization view
        var listNodesOfParent = _lodash.default.find(orgStructure, {
          level: selectedOrganization - 1
        }).nodes;
        if (!_lodash.default.isEmpty(listNodesOfParent)) {
          var parentNode = _lodash.default.find(listNodesOfParent, function (node) {
            return selectedNode.nodePath && selectedNode.nodePath.includes(node.nodePath.concat('|'));
          });
          // if node doesn't have parent then return all current node
          if (!parentNode) {
            return selectedOrgNodes;
          }
          parentNodePath = parentNode.nodePath;
        }
      }
      return selectedOrgNodes.filter(function (node) {
        return selectedNode.nodePath && node.nodePath.includes(parentNodePath.concat('|'));
      });
    }
    return selectedOrgNodes;
  };

  /**
   * Handle click button view all
   * @param {Number} level
   */
  var handleClickViewAll = function handleClickViewAll(level) {
    setShowDetailPane(true);
    setSelectedOrg(level);
    setOrgNodesDetail(filterSelectedOrgNodes(level));
  };

  // Handle close panel full
  var handleClosePanel = function handleClosePanel() {
    setSelectedNode(props.selectedNode);
    setShowDetailPane(false);
    setSelectedOrg(null);
    onClose();
  };

  /**
   * Handle select radio button to choose node
   * @param {Object} node
   */
  var handleClickRadioBtn = function handleClickRadioBtn(node) {
    setSelectedNode(node);
  };

  // Handle click button Save
  var handleClickSaveBtn = function handleClickSaveBtn() {
    if (selectedNode || enableClearSelection) {
      onSave(selectedNode);
    }
    setShowDetailPane(false);
    setSelectedOrg(null);
    onClose();
  };

  // Handle click button Clear Selection
  var handleClickClearSelection = function handleClickClearSelection() {
    if (selectedOrg === 1) {
      // In case of clear selection at first level
      setSelectedNode(null);
      return;
    }
    // Find the related parent node of selected node from the previous level
    var prevLevel = selectedOrg - 1;
    var prevLevelNodeDetails = _lodash.default.find(orgStructure, {
      level: prevLevel
    }).nodes;
    if (!_lodash.default.isEmpty(prevLevelNodeDetails)) {
      var parentNode = prevLevelNodeDetails.find(function (node) {
        return selectedNode.nodePath.includes(node.nodePath.concat('|'));
      });
      setSelectedNode(parentNode);
    }
  };

  /**
   * Return true if node is selected node or node is parent organization of selected node.
   * @param {Object} node
   * @returns {Boolean}
   */
  var isCheckedRadioBtn = function isCheckedRadioBtn(node) {
    return !_lodash.default.isNil(selectedNode) && (selectedNode.nodeId === node.nodeId || selectedNode.nodePath.includes(node.nodePath.concat('|')));
  };

  /**
   * Render summary organization and View All button
   * @param {String} name // name of organization
   * @param {Level} level
   */
  var renderSummaryField = function renderSummaryField(name, levelField) {
    // Current selected node level
    var selectedNodeLevel = selectedNode ? getLevelByNodePath(selectedNode.nodePath) : -1;
    var listNodes = selectedNodeLevel !== -1 ? _lodash.default.find(orgStructure, {
      level: levelField
    }).nodes : [];
    // get associated node to selected node
    var associatedChildNodes = levelField > selectedNodeLevel ? _lodash.default.filter(listNodes, function (node) {
      return node.nodePath.includes(selectedNode.nodePath.concat('|'));
    }) : [];
    // This level's selected node
    var parentOfSelectedNode = listNodes && selectedNode ? _lodash.default.filter(listNodes, function (node) {
      return selectedNode.nodePath.includes(node.nodePath.concat('|')) || selectedNode.nodePath === node.nodePath;
    })[0] : null;
    // Selected node name of this level
    var selectedNodeName = !_lodash.default.isNil(parentOfSelectedNode) ? parentOfSelectedNode.name : '';

    // don't show current summary field when this level don't have node
    if (selectedNodeLevel !== -1 && levelField > selectedNodeLevel && associatedChildNodes.length === 0) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "summary-structure-field ".concat(levelField === selectedOrg ? 'active' : ''),
      key: "summary-".concat(levelField)
    }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
      className: "title-hierarchy"
    }, name, " (", _lodash.default.isNil(parentOfSelectedNode) ? 0 : 1, ")", /*#__PURE__*/_react.default.createElement("span", {
      className: "view-all-btn-holder"
    }, /*#__PURE__*/_react.default.createElement(_buttonV.default, {
      muiButtonProps: {
        className: 'view-all-btn',
        variant: 'text',
        sx: _styles2.viewAllBtn,
        endIcon: /*#__PURE__*/_react.default.createElement("i", {
          className: "fa fa-arrow-right",
          "aria-hidden": "true"
        }),
        onClick: function onClick() {
          return handleClickViewAll(levelField);
        }
      }
    }, t('View All')))), selectedNodeName ? /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", {
      className: "small-text"
    }, selectedNodeName)) : /*#__PURE__*/_react.default.createElement("div", {
      className: "small-text"
    }, t('Select'), " ", name));
  };

  /**
   * Render nodes of organization
   * @param {Object} data // list nodes of organization
   */
  var renderStructureDetails = function renderStructureDetails(data) {
    var isDisabledOrgNodes = selectedNode && selectedOrg <= getLevelByNodePath(selectedNode.nodePath) && orgNodesDetail && orgNodesDetail.length === 1;
    if (!data) {
      return null;
    }
    return data.map(function (field) {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: "node-".concat(field.nodeId),
        className: "structure-details-field ".concat(isDisabledOrgNodes && 'disable-org')
      }, /*#__PURE__*/_react.default.createElement(_radioButton.default, {
        label: field.name,
        checked: isCheckedRadioBtn(field),
        onChange: function onChange() {
          return handleClickRadioBtn(field);
        }
      }));
    });
  };
  var renderActions = function renderActions() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "actions-btn"
    }, /*#__PURE__*/_react.default.createElement(_buttonV.default, {
      muiButtonProps: {
        onClick: handleClickSaveBtn,
        disabled: isLoading
      }
    }, t('Save')), /*#__PURE__*/_react.default.createElement(_buttonV.default, {
      muiButtonProps: {
        sx: _styles2.cancelBtn,
        color: 'secondary',
        variant: 'outlined',
        onClick: handleClosePanel
      }
    }, t('Cancel')));
  };

  /**
   * Render Clear Selection button when user selected a node
   */
  var renderClearSelection = function renderClearSelection() {
    return !_lodash.default.isNil(selectedNode) && _lodash.default.isNumber(selectedOrg) && selectedOrg <= getLevelByNodePath(selectedNode.nodePath) && /*#__PURE__*/_react.default.createElement("span", {
      className: "clear-selection"
    }, /*#__PURE__*/_react.default.createElement(_buttonV.default, {
      muiButtonProps: {
        className: 'btn-clear',
        onClick: handleClickClearSelection
      }
    }, t('Clear Selection')));
  };
  return /*#__PURE__*/_react.default.createElement(_Drawer.default, {
    className: "".concat(showDetailPane ? _styles.default['full-drawer-container'] : _styles.default['half-drawer-container']),
    anchor: "right",
    open: show,
    onClose: handleClosePanel
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "structure-summary"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "org-title"
  }, t('Organizational Structure:')), /*#__PURE__*/_react.default.createElement("div", {
    className: "level-container"
  }, isLoading ? /*#__PURE__*/_react.default.createElement(_spinner.default, null) : orgStructure.map(function (o) {
    return renderSummaryField(t(o.name), o.level);
  }), renderActions())), showDetailPane && /*#__PURE__*/_react.default.createElement(_Drawer.default, {
    className: _styles.default['structure-detail-drawer'],
    anchor: "right",
    variant: "persistent",
    open: showDetailPane
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "structure-detail"
  }, /*#__PURE__*/_react.default.createElement(_buttonV.default, {
    muiButtonProps: {
      variant: 'text',
      sx: _styles2.closeBtn,
      color: 'text',
      endIcon: /*#__PURE__*/_react.default.createElement("i", {
        className: "fa fa-times",
        "aria-hidden": "true"
      }),
      onClick: function onClick() {
        setShowDetailPane(false);
        setSelectedOrg(null);
      }
    }
  }, t('Close')), /*#__PURE__*/_react.default.createElement("div", {
    className: "line-title"
  }, enableClearSelection && renderClearSelection()), /*#__PURE__*/_react.default.createElement("hr", null), renderStructureDetails(orgNodesDetail))));
};
SingleDrawer.propTypes = {
  onClose: _propTypes.default.func.isRequired,
  onSave: _propTypes.default.func.isRequired,
  show: _propTypes.default.bool.isRequired,
  orgStructure: _propTypes.default.arrayOf(_propTypes.default.shape({})),
  selectedNode: _propTypes.default.number,
  isLoading: _propTypes.default.bool,
  enableClearSelection: _propTypes.default.bool,
  t: _propTypes.default.func
};
SingleDrawer.defaultProps = {
  orgStructure: [],
  selectedNode: null,
  isLoading: false,
  enableClearSelection: false,
  t: function t(x) {
    return x;
  }
};
var _default = SingleDrawer;
exports.default = _default;